(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.BadgeBuzzBundle = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  var QUOTE_ENDPOINT = "/apps/bb-portal/portal/v1/bundles/quote";
  var ARTWORK_REQUIRED_MESSAGE =
    "Approve a design for each customized product before adding this bundle.";
  var quoteCache = new Map();
  var CURRENT_LANYARD_PRODUCTS = [
    "bulldog-metal-clip-lanyards",
    "metal-hook-lanyards",
    "plastic-hook-lanyards",
  ];
  var BUNDLES = {
    "the-basics-bundle": {
      badgeProducts: ["paper-name-badge", "tear-resistant-name-badge"],
      lanyardProducts: CURRENT_LANYARD_PRODUCTS,
      lanyardModes: ["Solid Color"],
      includesAdhesive: false,
    },
    "flexible-bundle": {
      badgeProducts: ["tear-resistant-name-badge", "butterfly-name-badge"],
      lanyardProducts: CURRENT_LANYARD_PRODUCTS,
      lanyardModes: ["Customized", "Solid Color"],
      includesAdhesive: false,
    },
    "the-premier-bundle": {
      badgeProducts: ["plastic-name-badge"],
      lanyardProducts: CURRENT_LANYARD_PRODUCTS,
      lanyardModes: ["Customized"],
      includesAdhesive: true,
    },
  };

  function normalize(value) {
    return String(value == null ? "" : value)
      .trim()
      .toLowerCase()
      .replace(/[×"]/g, function (mark) {
        return mark === "×" ? "x" : "";
      })
      .replace(/\s+/g, " ");
  }

  function titleCaseDisplay(value) {
    var catalog =
      typeof globalThis !== "undefined" &&
      globalThis.BadgeBuzzProductOptionCatalog;
    if (catalog && typeof catalog.titleCaseDisplay === "function") {
      return catalog.titleCaseDisplay(value);
    }
    return String(value == null ? "" : value).replace(
      /(^|[^A-Za-z0-9])([A-Za-z]+(?:'[A-Za-z]+)?)/g,
      function (match, prefix, word) {
        if (/^(?:cm|mm|in|ft|oz|lb|lbs|px)$/i.test(word))
          return prefix + word;
        if (word.length > 1 && word === word.toUpperCase())
          return prefix + word;
        return prefix + word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      },
    );
  }

  function numericId(value) {
    var match = String(value == null ? "" : value).match(/(\d+)$/);
    if (!match) return null;
    var id = Number(match[1]);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
  }

  function findVariant(product, selectedOptions) {
    if (!product || !Array.isArray(product.variants)) return null;
    var wanted = (selectedOptions || []).map(normalize);
    return (
      product.variants.find(function (variant) {
        var options = (variant.options || []).map(normalize);
        return wanted.every(function (value, index) {
          return !value || options[index] === value;
        });
      }) || null
    );
  }

  function componentFromController(role, handle, product, controllerState) {
    if (!product || !controllerState || !controllerState.ready) return null;
    var productId = numericId(controllerState.productId);
    var variantId = numericId(controllerState.variantId);
    if (
      !productId ||
      !variantId ||
      !controllerState.configuration ||
      typeof controllerState.configuration !== "object"
    )
      return null;
    var variant = (product.variants || []).find(function (item) {
      return String(item.id) === String(variantId);
    });
    if (!variant) return null;
    return {
      role: role,
      handle: handle,
      product: product,
      variant: variant,
      productId: productId,
      variantId: variantId,
      configuration: Object.assign({}, controllerState.configuration),
      properties: Object.assign({}, controllerState.properties || {}),
      artworkProperties: Object.assign(
        {},
        controllerState.artworkProperties || {},
      ),
      artworkState: controllerState.artworkState || "empty",
    };
  }

  function buildQuotePayload(bundleHandle, components, quantity) {
    var payload = {
      bundle_handle: String(bundleHandle || ""),
      components: (components || []).map(function (component) {
        return {
          role: component.role,
          product_gid:
            "gid://shopify/Product/" + numericId(component.productId),
          variant_gid:
            "gid://shopify/ProductVariant/" + numericId(component.variantId),
          configuration: Object.assign({}, component.configuration || {}),
        };
      }),
    };
    if (Number.isSafeInteger(Number(quantity)) && Number(quantity) > 0)
      payload.quantity = Number(quantity);
    return payload;
  }

  function stableValue(value) {
    if (Array.isArray(value)) return value.map(stableValue);
    if (!value || typeof value !== "object") return value;
    return Object.keys(value)
      .sort()
      .reduce(function (result, key) {
        result[key] = stableValue(value[key]);
        return result;
      }, {});
  }

  function quoteFingerprint(payload) {
    return JSON.stringify(stableValue(payload));
  }

  function normalizedSupportedQuantities(values) {
    var seen = {};
    return (Array.isArray(values) ? values : [])
      .reduce(function (result, value) {
        var quantity = Number(value);
        if (
          !Number.isSafeInteger(quantity) ||
          quantity < 1 ||
          quantity > 100000 ||
          seen[quantity]
        )
          return result;
        seen[quantity] = true;
        result.push(quantity);
        return result;
      }, [])
      .sort(function (a, b) {
        return a - b;
      });
  }

  function quoteSupportsQuantity(quote, quantity) {
    if (!quote || (quote.errors || []).length) return false;
    return (
      normalizedSupportedQuantities(quote.supported_quantities).indexOf(
        Number(quantity),
      ) !== -1
    );
  }

  function createQuoteRequester(fetchImpl, cache, nowImpl) {
    var latestToken = 0;
    var activeRequest = null;
    cache = cache || new Map();
    nowImpl = nowImpl || Date.now;

    function expired(entry) {
      var expiresAt =
        entry && entry.quote && Date.parse(entry.quote.expires_at || "");
      return Number.isFinite(expiresAt) && expiresAt <= Number(nowImpl());
    }

    function request(payload) {
      var token = ++latestToken;
      var fingerprint = quoteFingerprint(payload);
      var cached = cache.get(fingerprint);
      if (expired(cached)) {
        cache.delete(fingerprint);
        cached = null;
      }
      if (activeRequest && activeRequest.fingerprint !== fingerprint) {
        if (
          activeRequest.controller &&
          typeof activeRequest.controller.abort === "function"
        )
          activeRequest.controller.abort();
        activeRequest = null;
      }
      var pending = cached && cached.promise ? cached.promise : cached;
      if (!pending) {
        var controller =
          typeof AbortController !== "undefined" ? new AbortController() : null;
        var entry = {
          fingerprint: fingerprint,
          controller: controller,
          promise: null,
        };
        var options = {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        };
        if (controller) options.signal = controller.signal;
        pending = Promise.resolve(fetchImpl(QUOTE_ENDPOINT, options))
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok || !data || data.version !== 1) {
                var error = new Error("Bundle quote unavailable");
                error.quote = data || null;
                throw error;
              }
              return data;
            });
          })
          .then(function (data) {
            entry.quote = data;
            return data;
          });
        entry.promise = pending;
        activeRequest = entry;
        cache.set(fingerprint, entry);
        pending.then(
          function () {
            if (activeRequest === entry) activeRequest = null;
          },
          function () {
            if (cache.get(fingerprint) === entry) cache.delete(fingerprint);
            if (activeRequest === entry) activeRequest = null;
          },
        );
      }
      return pending.then(function (quote) {
        return token === latestToken
          ? { stale: false, quote: quote }
          : { stale: true, quote: null };
      });
    }

    function cancel() {
      latestToken += 1;
      if (
        activeRequest &&
        activeRequest.controller &&
        typeof activeRequest.controller.abort === "function"
      )
        activeRequest.controller.abort();
      activeRequest = null;
    }

    return { request: request, cancel: cancel };
  }

  function safeLineProperties(component) {
    var properties = Object.assign(
      {},
      component.properties || {},
      component.artworkProperties || {},
    );
    Object.keys(properties).forEach(function (key) {
      if (
        key === "Bundle" ||
        key === "Delivery date" ||
        key === "_BadgeBuzz configuration" ||
        key === "_BadgeBuzz offer" ||
        key === "_BadgeBuzz printing method" ||
        key.indexOf("_bb_bundle_") === 0 ||
        /^_?requested_(price|discount|multiplier)$/i.test(key)
      )
        delete properties[key];
      else if (/^color\s*:/i.test(key) && Number(properties[key]) === 0)
        delete properties[key];
    });
    return properties;
  }

  function buildCartLines(configuration) {
    var quoteLines =
      configuration.quoteOption && configuration.quoteOption.lines;
    if (!Array.isArray(quoteLines)) return [];
    return (configuration.components || []).reduce(function (lines, component) {
      var quoteLine = quoteLines.find(function (line) {
        return (
          line &&
          line.role === component.role &&
          numericId(line.variant_gid) === numericId(component.variantId)
        );
      });
      var quantity = quoteLine && Number(quoteLine.quantity);
      if (
        !quoteLine ||
        !Number.isSafeInteger(quantity) ||
        quantity < 1 ||
        !quoteLine.delivery_date ||
        !quoteLine.configuration
      )
        return lines;
      var properties = safeLineProperties(component);
      properties.Bundle = configuration.bundleTitle;
      properties["Delivery date"] = quoteLine.delivery_date;
      properties["_BadgeBuzz configuration"] = quoteLine.configuration;
      if (quoteLine.printing_method_code) {
        properties["_BadgeBuzz printing method"] =
          quoteLine.printing_method_code;
      }
      properties._bb_bundle_key = configuration.bundleKey;
      properties._bb_bundle_handle = configuration.bundleHandle;
      properties._bb_bundle_role = component.role;
      lines.push({
        id: numericId(component.variantId),
        quantity: quantity,
        properties: properties,
      });
      return lines;
    }, []);
  }

  function addResponseMatches(expected, response) {
    if (
      !response ||
      !Array.isArray(response.items) ||
      response.items.length !== expected.length
    )
      return false;
    var remaining = response.items.slice();
    return expected.every(function (line) {
      var index = remaining.findIndex(function (item) {
        return (
          String(item.id) === String(line.id) &&
          Number(item.quantity) === Number(line.quantity)
        );
      });
      if (index === -1) return false;
      remaining.splice(index, 1);
      return true;
    });
  }

  function rollbackUpdates(response) {
    return ((response && response.items) || []).reduce(function (
      updates,
      item,
    ) {
      if (item && item.key) updates[item.key] = 0;
      return updates;
    }, {});
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatMoney(value, currency) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return "—";
    if (typeof window !== "undefined" && window.BadgeBuzzMoney) {
      return window.BadgeBuzzMoney.format(amount, {
        currency: currency || "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "USD",
      }).format(amount);
    } catch (error) {
      return "$" + amount.toFixed(2);
    }
  }

  function formatDiscountPercent(basisPoints) {
    var percent = Number(basisPoints) / 100;
    if (!Number.isFinite(percent) || percent <= 0) return "";
    return (
      percent
        .toFixed(2)
        .replace(/\.00$/, "")
        .replace(/(\.\d)0$/, "$1") + "%"
    );
  }

  function bundleDeliveryOptions(quote, quantity) {
    var safeQuantity = Number(quantity);
    var currency = (quote && quote.currency) || "USD";
    if (!Number.isSafeInteger(safeQuantity) || safeQuantity < 1) return [];
    return ((quote && quote.options) || []).map(function (option) {
      var total = Number(option && option.total);
      return Object.assign({}, option, {
        currency: currency,
        per_unit: Number.isFinite(total) ? total / safeQuantity : null,
      });
    });
  }

  function quoteForQuantity(matrix, quantity) {
    var safeQuantity = Number(quantity);
    if (
      !Number.isSafeInteger(safeQuantity) ||
      safeQuantity < 1 ||
      !quoteSupportsQuantity(matrix, safeQuantity)
    )
      return null;
    var entry =
      matrix && matrix.quantities && matrix.quantities[String(safeQuantity)];
    if (
      !entry ||
      typeof entry.currency !== "string" ||
      !/^[A-Z]{3}$/.test(entry.currency) ||
      !Array.isArray(entry.options) ||
      !entry.options.length
    )
      return null;
    var valid = entry.options.every(function (option) {
      return (
        option &&
        /^\d{4}-\d{2}-\d{2}$/.test(String(option.date || "")) &&
        Number.isFinite(Number(option.total)) &&
        Array.isArray(option.lines) &&
        option.lines.length > 0 &&
        option.lines.every(function (line) {
          return (
            line &&
            Number(line.quantity) === safeQuantity &&
            numericId(line.variant_gid) &&
            line.delivery_date &&
            line.configuration
          );
        })
      );
    });
    if (!valid) return null;
    return Object.assign({}, matrix, {
      currency: entry.currency,
      options: bundleDeliveryOptions(
        { currency: entry.currency, options: entry.options },
        safeQuantity,
      ),
    });
  }

  function defaultBundleDeliveryOption(options, deliveryUI) {
    var candidates = Array.isArray(options) ? options : [];
    if (deliveryUI && typeof deliveryUI.earliestDeliveryOption === "function") {
      return deliveryUI.earliestDeliveryOption(candidates) || null;
    }
    return (
      candidates.reduce(function (earliest, option) {
        var date = option && String(option.date || "");
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return earliest;
        return !earliest || date < earliest.date ? option : earliest;
      }, null) ||
      candidates[0] ||
      null
    );
  }

  function choiceGroup(label, key, values, selected) {
    if (
      !values.length ||
      (values.length === 1 && normalize(values[0]) === "default title")
    )
      return "";
    var hasImages = values.some(function (item) {
      return item && typeof item === "object" && item.image;
    });
    return (
      '<div class="bb-field">' +
      '<div class="bb-field__hd"><span class="bb-field__label">' +
      escapeHtml(label) +
      "</span></div>" +
      '<div class="' +
      (hasImages ? "bb-optcards" : "bb-visual-radios") +
      '" role="radiogroup" aria-label="' +
      escapeHtml(label) +
      '">' +
      values
        .map(function (item) {
          var value = item && typeof item === "object" ? item.value : item;
          var display = item && typeof item === "object" ? item.label : item;
          var image = item && typeof item === "object" ? item.image : "";
          var active = normalize(value) === normalize(selected);
          return (
            '<button class="' +
            (image ? "bb-optcard" : "bb-visual-radio-btn") +
            (active ? " selected active" : "") +
            '" type="button" data-bb-choice="' +
            escapeHtml(key) +
            '" data-bb-value="' +
            escapeHtml(value) +
            '" role="radio" aria-checked="' +
            (active ? "true" : "false") +
            '" aria-pressed="' +
            (active ? "true" : "false") +
            '">' +
            (image
              ? '<div class="bb-optcard__img" aria-hidden="true"><img src="' +
                escapeHtml(image) +
                '" alt="" loading="lazy"></div><div class="bb-optcard__name">' +
                escapeHtml(display) +
                "</div>"
              : escapeHtml(display)) +
            "</button>"
          );
        })
        .join("") +
      "</div></div>"
    );
  }

  function lanyardFamilyChoice(selectedHandle, families) {
    families = Array.isArray(families) ? families : [];
    return (
      '<div class="bb-field">' +
      '<div class="bb-field__hd"><span class="bb-field__label">Attachment Type</span>' +
      '<button class="bb-field__help" type="button" data-tooltip-title="Attachment Type" data-tooltip="Choose the main hardware family. Each family has its own compatible attachment styles and widths." aria-label="Attachment type info">?</button></div>' +
      '<p class="bb-field__desc">Choose the hardware family for your lanyard.</p>' +
      '<div class="bb-lp-family__track" role="radiogroup" aria-label="Lanyard attachment type">' +
      families
        .map(function (family) {
          var active = normalize(family.handle) === normalize(selectedHandle);
          return (
            '<button class="bb-lp-family__option' +
            (active ? ' selected active' : '') +
            '" type="button" data-bb-choice="lanyard-product" data-bb-value="' +
            escapeHtml(family.handle) +
            '" role="radio" aria-checked="' +
            (active ? 'true' : 'false') +
            '" aria-pressed="' +
            (active ? 'true' : 'false') +
            '"><span class="bb-lp-family__dot" aria-hidden="true"></span>' +
            '<span class="bb-lp-family__label">' +
            escapeHtml(family.label) +
            '</span></button>'
          );
        })
        .join('') +
      '</div></div>'
    );
  }

  function featuredProductImage(product) {
    if (!product) return "";
    if (typeof product.featured_image === "string")
      return product.featured_image;
    if (
      product.featured_image &&
      typeof product.featured_image.src === "string"
    )
      return product.featured_image.src;
    if (Array.isArray(product.images) && product.images.length) {
      var image = product.images[0];
      return typeof image === "string" ? image : image && image.src;
    }
    return "";
  }

  function controllerLoadingPanel(label) {
    return (
      '<div class="bb-product-controller-loading" data-bb-controller-loading role="status" aria-live="polite">' +
      '<span class="bb-product-controller-loading__label">Loading ' +
      escapeHtml(label || "product") +
      " options…</span>" +
      '<span class="bb-skeleton bb-product-controller-loading__line"></span>' +
      '<span class="bb-skeleton bb-product-controller-loading__choice"></span>' +
      '<span class="bb-skeleton bb-product-controller-loading__choice"></span>' +
      '<span class="bb-skeleton bb-product-controller-loading__line bb-product-controller-loading__line--short"></span>' +
      '<span class="bb-skeleton bb-product-controller-loading__card"></span>' +
      "</div>"
    );
  }

  function productOptionCatalog() {
    return typeof window !== "undefined"
      ? window.BadgeBuzzProductOptionCatalog
      : null;
  }

  function controllerRequest(role, handle, product) {
    var catalog = productOptionCatalog();
    if (catalog && !catalog.get(handle))
      throw new Error("This product configuration is unavailable.");
    var materialByHandle = {
      "paper-name-badge": "paper",
      "tear-resistant-name-badge": "tear-resistant",
      "butterfly-name-badge": "butterfly",
      "plastic-name-badge": "plastic",
    };
    var kind = role === "badge" ? "name-badge" : role;
    var sectionId =
      kind === "name-badge"
        ? "bb-name-badge-product"
        : kind === "lanyard"
          ? "bb-lanyard-product"
          : "bb-adhesive-product";
    var variant = product && product.variants && product.variants[0];
    var properties = {};
    if (materialByHandle[handle])
      properties.Material = materialByHandle[handle];
    return {
      handle: handle,
      productId: product && numericId(product.id),
      sectionId: sectionId,
      kind: kind,
      label: product && product.title ? product.title : handle,
      initialVariantId: variant ? variant.id : null,
      initialProperties: properties,
    };
  }

  function productChoice(
    products,
    handles,
    selectedHandle,
    key,
    label,
    choiceImages,
  ) {
    return choiceGroup(
      label,
      key,
      handles.map(function (handle) {
        return {
          value: handle,
          label: products[handle] ? products[handle].title : handle,
          image:
            (choiceImages && choiceImages[handle]) ||
            featuredProductImage(products[handle]),
        };
      }),
      selectedHandle,
    );
  }

  function defaultState(definition) {
    return {
      badgeHandle: definition.badgeProducts[0],
      lanyardHandle: definition.lanyardProducts[0],
      lanyardMode: definition.lanyardModes[0],
      quantity: null,
      quotePending: true,
      busy: false,
      quote: null,
      quoteMatrix: null,
      selectedOption: null,
      message: "Loading bundle options…",
      messageType: "",
    };
  }

  function defaultSelectionForBundle(handle) {
    var definition = BUNDLES[String(handle || "")];
    if (!definition) return null;
    var state = defaultState(definition);
    return {
      badgeHandle: state.badgeHandle,
      lanyardHandle: state.lanyardHandle,
      lanyardMode: state.lanyardMode,
    };
  }

  function expectedComponentCount(instance) {
    return instance.definition.includesAdhesive ? 3 : 2;
  }

  function selectedComponents(instance) {
    var state = instance.state;
    var products = instance.products;
    var components = [];
    var badge = products[state.badgeHandle];
    var badgeState =
      instance.controllers.badge && instance.controllers.badge.snapshot();
    var badgeComponent = componentFromController(
      "badge",
      state.badgeHandle,
      badge,
      badgeState,
    );
    if (badgeComponent)
      components.push(attachArtwork(instance, badgeComponent));

    if (instance.definition.includesAdhesive) {
      var adhesive = products["adhesive-name-badge"];
      var adhesiveState =
        instance.controllers.adhesive &&
        instance.controllers.adhesive.snapshot();
      var adhesiveComponent = componentFromController(
        "adhesive",
        "adhesive-name-badge",
        adhesive,
        adhesiveState,
      );
      if (adhesiveComponent)
        components.push(attachArtwork(instance, adhesiveComponent));
    }

    var lanyardHandle = state.lanyardHandle;
    var lanyard = products[lanyardHandle];
    var lanyardState =
      instance.controllers.lanyard && instance.controllers.lanyard.snapshot();
    var lanyardComponent = componentFromController(
      "lanyard",
      lanyardHandle,
      lanyard,
      lanyardState,
    );
    if (lanyardComponent)
      components.push(attachArtwork(instance, lanyardComponent));
    return components;
  }

  function componentNeedsArtwork(role, lanyardMode, snapshot, productHandle) {
    if (role === "lanyard") return lanyardMode === "Customized";
    if (
      productHandle === "butterfly-name-badge" ||
      productHandle === "adhesive-name-badge"
    )
      return false;
    var configuration = (snapshot && snapshot.configuration) || {};
    var properties = (snapshot && snapshot.properties) || {};
    return (
      String(configuration.Design || properties.Design || "")
        .trim()
        .toLowerCase() !== "blank"
    );
  }

  function requiredArtworkRoles(instance) {
    var roles = [];
    var badge =
      instance.controllers.badge && instance.controllers.badge.snapshot();
    var adhesive =
      instance.controllers.adhesive && instance.controllers.adhesive.snapshot();
    var lanyard =
      instance.controllers.lanyard && instance.controllers.lanyard.snapshot();
    if (
      componentNeedsArtwork(
        "badge",
        instance.state.lanyardMode,
        badge,
        instance.state.badgeHandle,
      )
    )
      roles.push("badge");
    if (
      instance.definition.includesAdhesive &&
      componentNeedsArtwork(
        "adhesive",
        instance.state.lanyardMode,
        adhesive,
        "adhesive-name-badge",
      )
    )
      roles.push("adhesive");
    if (componentNeedsArtwork("lanyard", instance.state.lanyardMode, lanyard))
      roles.push("lanyard");
    return roles;
  }

  function artworkForRole(instance, role) {
    var artwork = instance.artworkByRole[role];
    var controller = instance.controllers[role];
    var designApi =
      typeof window !== "undefined" && window.BadgeBuzzProductDesignController;
    if (
      !artwork ||
      !controller ||
      !designApi ||
      typeof designApi.selectionFingerprint !== "function"
    )
      return null;
    return artwork.fingerprint ===
      designApi.selectionFingerprint(
        bundleDesignSelection(instance, role, controller),
      )
      ? artwork
      : null;
  }

  function bundleDesignSelection(instance, role, controller) {
    var selection =
      controller && typeof controller.snapshot === "function"
        ? controller.snapshot()
        : null;
    if (!selection) return selection;
    var lines =
      instance &&
      instance.state &&
      instance.state.selectedOption &&
      instance.state.selectedOption.lines;
    var line = Array.isArray(lines)
      ? lines.find(function (candidate) {
          return candidate && candidate.role === role;
        })
      : null;
    return Object.assign({}, selection, {
      printingMethod: String(
        (line && line.printing_method_code) || "",
      ).trim(),
    });
  }

  function attachArtwork(instance, component) {
    var artwork = artworkForRole(instance, component.role);
    component.artworkProperties = artwork
      ? Object.assign({}, artwork.properties || {})
      : {};
    component.artworkState = artwork ? "ready" : "empty";
    return component;
  }

  function hasRequiredArtwork(instance) {
    return requiredArtworkRoles(instance).every(function (role) {
      return Boolean(artworkForRole(instance, role));
    });
  }

  function missingArtworkRoles(instance) {
    return requiredArtworkRoles(instance).filter(function (role) {
      return !artworkForRole(instance, role);
    });
  }

  function designActionsForRole(instance, role) {
    var controller = instance.designControllers[role];
    if (controller && controller.actionsRoot) return controller.actionsRoot;
    return (
      instance.controls &&
      instance.controls.querySelector(
        '[data-bb-section-controller-slot="' +
          role +
          '"] [data-bb-product-design-actions]',
      )
    );
  }

  function guideMissingArtwork(instance) {
    var role = missingArtworkRoles(instance)[0];
    var target = role && designActionsForRole(instance, role);
    if (!target) return false;
    var status = target.querySelector("[data-bb-design-status]");
    var title = status && status.querySelector("[data-bb-design-status-title]");
    var detail =
      status && status.querySelector("[data-bb-design-status-detail]");
    if (title) title.textContent = "Design required";
    if (detail)
      detail.textContent =
        "Create or upload a design for this product before adding the bundle.";
    if (status) {
      if (!title || !detail)
        status.textContent =
          "Design required. Create or upload a design for this product before adding the bundle.";
      status.dataset.bbDesignState = "required";
      status.classList.add("is-error");
      status.setAttribute("role", "alert");
      status.hidden = false;
    }
    target.dataset.bbDesignValidation = "error";
    var win = target.ownerDocument && target.ownerDocument.defaultView;
    if (win && win.BBToast && typeof win.BBToast.show === "function") {
      win.BBToast.show({
        variant: "warning",
        title: "Complete your bundle designs",
        message: "Create or upload a design for the highlighted product.",
        dedupeKey: "bundle-artwork-required",
      });
    }
    if (typeof target.scrollIntoView === "function") {
      var reduceMotion =
        win &&
        typeof win.matchMedia === "function" &&
        win.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target.scrollIntoView({
        behavior: reduceMotion ? "auto" : "smooth",
        block: "center",
      });
    }
    var focusTarget = target.querySelector(
      "[data-bb-open-zakeke], [data-bb-upload-button]",
    );
    if (focusTarget && typeof focusTarget.focus === "function") {
      (win || window).setTimeout(function () {
        focusTarget.focus({ preventScroll: true });
      }, 250);
    }
    return true;
  }

  function syncDesignArtwork(instance) {
    Object.keys(instance.designControllers).forEach(function (role) {
      var controller = instance.designControllers[role];
      var artwork = artworkForRole(instance, role);
      if (controller) controller.setArtwork(artwork);
      if (!artwork && instance.artworkByRole[role])
        delete instance.artworkByRole[role];
    });
  }

  function updateCollectedArtwork(instance, role, artwork) {
    if (artwork) instance.artworkByRole[role] = artwork;
    else delete instance.artworkByRole[role];
    if (instance.state.message === ARTWORK_REQUIRED_MESSAGE) {
      instance.state.message = "";
      instance.state.messageType = "";
    }
    renderSummary(instance);
  }

  function syncControllerQuantity(instance) {
    if (!instance.state.quantity) return;
    instance.syncingQuantity = true;
    Object.keys(instance.controllers).forEach(function (role) {
      var controller = instance.controllers[role];
      if (controller && typeof controller.setQuantity === "function")
        controller.setQuantity(instance.state.quantity);
    });
    syncDesignArtwork(instance);
    window.setTimeout(function () {
      instance.syncingQuantity = false;
    }, 0);
  }

  function componentSection(number, title, subtitle, body) {
    return (
      '<section data-bb-bundle-component class="bb-product-step">' +
      '<div class="bb-product-step__heading"><h2 class="bb-product-step__title">' +
      number +
      ". " +
      escapeHtml(title) +
      '</h2><p class="bb-product-step__subtitle">' +
      escapeHtml(subtitle) +
      '</p></div><div class="bb-product-step__body">' +
      body +
      "</div></section>"
    );
  }

  function releaseControllers(instance) {
    Object.keys(instance.designControllers || {}).forEach(function (role) {
      var controller = instance.designControllers[role];
      if (controller && typeof controller.disconnect === "function")
        controller.disconnect();
    });
    Object.keys(instance.controllers).forEach(function (role) {
      var controller = instance.controllers[role];
      if (controller && typeof controller.disconnect === "function")
        controller.disconnect();
    });
    instance.controllers = {};
    instance.designControllers = {};
    instance.controllerTokens = {};
  }

  function resetQuantitySelect(instance, label) {
    if (!instance.quantity) return;
    instance.quantity.disabled = true;
    var option = instance.quantity.ownerDocument.createElement("option");
    option.value = "";
    option.textContent = label || "Loading quantities…";
    instance.quantity.replaceChildren(option);
  }

  function populateQuantitySelect(instance, quantities) {
    var previous = Number(instance.state.quantity);
    instance.quantity.replaceChildren();
    quantities.forEach(function (quantity) {
      var option = instance.quantity.ownerDocument.createElement("option");
      option.value = String(quantity);
      option.textContent = String(quantity);
      instance.quantity.appendChild(option);
    });
    instance.state.quantity =
      quantities.indexOf(previous) !== -1 ? previous : quantities[0] || null;
    instance.quantity.value = instance.state.quantity
      ? String(instance.state.quantity)
      : "";
    instance.quantity.disabled = true;
  }

  function publicQuoteMessage(quote) {
    var code = quote && quote.errors && quote.errors[0] && quote.errors[0].code;
    var messages = {
      bundle_inactive: "This bundle is temporarily unavailable.",
      bundle_component_missing: "Complete every product option to continue.",
      bundle_product_not_allowed:
        "One selected product is not available in this bundle.",
      bundle_quantity_unsupported:
        "Choose one of the available bundle quantities.",
      bundle_pricing_unavailable:
        "Current bundle pricing is unavailable. Please try again.",
      component_pricing_unavailable:
        "This bundle combination is temporarily unavailable. Please choose another option or try again later.",
    };
    return (
      messages[code] ||
      "Current bundle options could not be verified. Please review your selections and try again."
    );
  }

  function deliveryUIFor(instance) {
    return (
      instance.deliveryUI ||
      (typeof window !== "undefined" && window.BadgeBuzzDeliveryDateUI) ||
      null
    );
  }

  function deliveryUIReady(instance) {
    var deliveryUI = deliveryUIFor(instance);
    return Boolean(
      deliveryUI &&
      typeof deliveryUI.renderLoadingOptions === "function" &&
      typeof deliveryUI.renderOptionCards === "function",
    );
  }

  function renderDelivery(instance) {
    var delivery = instance.delivery;
    if (!delivery) return;
    var deliveryUI = deliveryUIFor(instance);
    if (deliveryUI && typeof deliveryUI.renderSelectedPrice === "function") {
      deliveryUI.renderSelectedPrice(delivery, null);
    }
    var optionsRoot = delivery.querySelector("[data-bb-delivery-options]");
    var more = delivery.querySelector("[data-bb-delivery-more]");
    var status = delivery.querySelector("[data-bb-delivery-status]");
    var heading = delivery.querySelector("[data-bb-bundle-delivery-heading]");
    var price = delivery.querySelector("[data-bb-bundle-delivery-price]");
    var selectedDate = delivery.querySelector("[data-bb-delivery-input]");
    var unitPrice =
      instance.root &&
      instance.root.querySelector("[data-bb-bundle-unit-price]");
    var options = (instance.state.quote && instance.state.quote.options) || [];
    var quantity = Number(instance.state.quantity);

    if (heading && Number.isSafeInteger(quantity) && quantity > 0) {
      heading.textContent = "Ready-to-ship options for " + quantity + " bundles";
    }

    if (instance.state.quotePending) {
      if (instance.quantity) instance.quantity.disabled = true;
      if (unitPrice) unitPrice.textContent = "";
      if (price) {
        price.textContent = "";
        price.hidden = true;
      }
      if (selectedDate) selectedDate.value = "";
      if (deliveryUI && typeof deliveryUI.renderLoadingOptions === "function") {
        deliveryUI.renderLoadingOptions(delivery);
      } else if (optionsRoot) {
        optionsRoot.replaceChildren();
      }
      if (status) status.textContent = "Loading pricing…";
      return;
    }

    if (
      !options.length ||
      !deliveryUI ||
      typeof deliveryUI.renderOptionCards !== "function"
    ) {
      if (unitPrice) unitPrice.textContent = "Pricing unavailable";
      if (price) {
        price.textContent = "";
        price.hidden = true;
      }
      if (optionsRoot) optionsRoot.replaceChildren();
      if (more) more.hidden = true;
      if (selectedDate) selectedDate.value = "";
      if (status)
        status.textContent =
          "Ready-to-ship options are unavailable for this configuration.";
      return;
    }

    if (instance.quantity) instance.quantity.disabled = false;
    var selected = instance.state.selectedOption;
    var selectedPerUnit = selected && Number(selected.per_unit);
    if (unitPrice) {
      unitPrice.textContent = Number.isFinite(selectedPerUnit)
        ? formatMoney(selectedPerUnit, instance.state.quote.currency) +
          " per bundle"
        : "";
    }
    var pricedOptions = options.filter(function (option) {
      return Number.isFinite(Number(option.total));
    });
    var fromTotal = pricedOptions.length
      ? Math.min.apply(
          null,
          pricedOptions.map(function (option) {
            return Number(option.total);
          }),
        )
      : null;
    if (price) {
      price.textContent =
        fromTotal == null
          ? ""
          : "From " +
            formatMoney(fromTotal, instance.state.quote.currency) +
            " total · " +
            formatMoney(fromTotal / quantity, instance.state.quote.currency) +
            " each";
      price.hidden = fromTotal == null;
    }
    if (selectedDate) selectedDate.value = (selected && selected.date) || "";
    deliveryUI.renderOptionCards(delivery, options, {
      currentDate: (selected && selected.date) || "",
      onSelect: function (option) {
        instance.state.selectedOption = option;
        instance.state.message = "";
        if (selectedDate) selectedDate.value = option.date || "";
        if (unitPrice) {
          var optionPerUnit = Number(option.per_unit);
          unitPrice.textContent = Number.isFinite(optionPerUnit)
            ? formatMoney(optionPerUnit, instance.state.quote.currency) +
              " per bundle"
            : "";
        }
        optionsRoot
          .querySelectorAll("[data-delivery-date-value]")
          .forEach(function (button) {
            button.setAttribute(
              "aria-pressed",
              String(button.dataset.deliveryDateValue === option.date),
            );
          });
        renderSummary(instance, { skipDelivery: true });
      },
    });
    if (status) status.textContent = "";
  }

  function renderSummary(instance, settings) {
    settings = settings || {};
    var state = instance.state;
    Object.keys(instance.designControllers || {}).forEach(function (role) {
      var actions = designActionsForRole(instance, role);
      var controller = instance.controllers[role];
      if (actions) {
        actions.hidden = !componentNeedsArtwork(
          role,
          state.lanyardMode,
          controller && controller.snapshot(),
          role === "badge" ? state.badgeHandle : role === "adhesive" ? "adhesive-name-badge" : state.lanyardHandle,
        );
      }
    });
    var components = selectedComponents(instance);
    var option = state.selectedOption;
    var lines = instance.summary.querySelector("[data-bb-bundle-lines]");
    var originalTotalElement = instance.summary.querySelector(
      "[data-bb-bundle-original-total]",
    );
    var totalElement = instance.summary.querySelector("[data-bb-bundle-total]");
    var discountElement = instance.summary.querySelector(
      "[data-bb-bundle-discount]",
    );
    var discountPercentElement = instance.summary.querySelector(
      "[data-bb-bundle-discount-percent]",
    );
    var discountAmountElement = instance.summary.querySelector(
      "[data-bb-bundle-discount-amount]",
    );
    var countElement = instance.summary.querySelector("[data-bb-bundle-count]");
    var addButton = instance.summary.querySelector("[data-bb-bundle-add]");
    var addLabel =
      addButton && addButton.querySelector(".bb-summary__cta-text strong");
    var status = instance.summary.querySelector("[data-bb-bundle-status]");
    var quotedLines = (option && option.lines) || [];
    var basisPoints = Number(state.quote && state.quote.discount_basis_points);
    var discountAmount = Number(option && option.discount);
    var hasDiscount =
      Boolean(option) &&
      Number.isFinite(basisPoints) &&
      basisPoints > 0 &&
      Number.isFinite(discountAmount) &&
      discountAmount > 0;
    var artworkReady = hasRequiredArtwork(instance);
    var canAttempt =
      !state.quotePending &&
      !state.busy &&
      deliveryUIReady(instance) &&
      components.length === expectedComponentCount(instance) &&
      option &&
      buildCartLines({ components: components, quoteOption: option }).length ===
        components.length;

    if (lines)
      lines.innerHTML = quotedLines
        .map(function (line) {
          var component = components.find(function (item) {
            return item.role === line.role;
          });
          var title =
            component && component.product
              ? component.product.title
              : line.role;
          var details = [];
          var variantTitle =
            component &&
            component.variant &&
            normalize(component.variant.title) !== "default title"
              ? component.variant.title
              : "";
          if (variantTitle) details.push(variantTitle);
          details.push(Number(line.quantity) + " Pieces");
          details.push(
            formatMoney(line.total, state.quote && state.quote.currency),
          );
          return (
            '<div class="bb-summary__row"><dt>' +
            escapeHtml(titleCaseDisplay(title)) +
            "</dt><dd>" +
            escapeHtml(titleCaseDisplay(details.join(" · "))) +
            "</dd></div>"
          );
        })
        .join("");
    if (originalTotalElement) {
      originalTotalElement.textContent = option
        ? formatMoney(option.base_total, state.quote && state.quote.currency)
        : "";
      originalTotalElement.hidden = !hasDiscount;
    }
    if (totalElement) {
      totalElement.textContent = state.quotePending
        ? "Pricing pending"
        : option
          ? formatMoney(option.total, state.quote.currency)
          : "—";
    }
    if (discountElement) discountElement.hidden = !hasDiscount;
    if (discountPercentElement)
      discountPercentElement.textContent = hasDiscount
        ? formatDiscountPercent(basisPoints)
        : "";
    if (discountAmountElement) {
      discountAmountElement.textContent = hasDiscount
        ? formatMoney(discountAmount, state.quote && state.quote.currency)
        : "";
    }
    if (countElement) {
      countElement.textContent = option
        ? quotedLines.length + " Components"
        : "Waiting for verified selections";
      countElement.hidden = false;
    }
    if (addButton) {
      addButton.disabled = !canAttempt;
      addButton.setAttribute(
        "aria-busy",
        state.busy || state.quotePending ? "true" : "false",
      );
    }
    if (addLabel)
      addLabel.textContent = state.busy
        ? "Adding bundle…"
        : state.quotePending
          ? "Checking bundle…"
          : "Add configured bundle to cart";
    if (status) {
      status.textContent =
        state.message ||
        (!state.quotePending && option && !artworkReady
          ? ARTWORK_REQUIRED_MESSAGE
          : "");
      status.dataset.bbMessageType = state.messageType;
      status.hidden = !status.textContent;
    }
    if (!settings.skipDelivery) renderDelivery(instance);
  }

  function failQuote(instance, cycle, error) {
    if (cycle !== instance.quoteCycle) return;
    instance.state.quotePending = false;
    instance.state.quote = null;
    instance.state.quoteMatrix = null;
    instance.state.selectedOption = null;
    instance.state.message = publicQuoteMessage(error && error.quote);
    instance.state.messageType = "error";
    instance.state.quantity = null;
    resetQuantitySelect(instance, "Quantities unavailable");
    renderSummary(instance);
  }

  function loadQuote(instance) {
    var cycle = ++instance.quoteCycle;
    var components = selectedComponents(instance);
    instance.state.quotePending = true;
    instance.state.quote = null;
    instance.state.quoteMatrix = null;
    instance.state.selectedOption = null;
    instance.state.message = "";
    instance.state.messageType = "";
    resetQuantitySelect(instance, "Checking quantities…");
    renderSummary(instance);
    if (components.length !== expectedComponentCount(instance)) {
      instance.state.quotePending = false;
      instance.state.message =
        "Complete every product option to load bundle quantities.";
      resetQuantitySelect(instance, "Complete product options first");
      renderSummary(instance);
      return;
    }

    return instance.quoteRequester
      .request(buildQuotePayload(instance.bundle.handle, components))
      .then(function (result) {
        if (result.stale || cycle !== instance.quoteCycle) return;
        var quantities = normalizedSupportedQuantities(
          result.quote.supported_quantities,
        );
        if ((result.quote.errors || []).length || !quantities.length) {
          var error = new Error("No supported bundle quantities");
          error.quote = result.quote;
          throw error;
        }
        instance.state.quoteMatrix = result.quote;
        populateQuantitySelect(instance, quantities);
        if (quoteForQuantity(result.quote, instance.state.quantity))
          return applyMatrixQuantity(instance);
        return loadSelectedQuantityQuote(instance, components);
      })
      .catch(function (error) {
        if (error && error.name === "AbortError") return;
        failQuote(instance, cycle, error);
      });
  }

  function loadSelectedQuantityQuote(instance, components) {
    var cycle = ++instance.quoteCycle;
    var quantity = Number(instance.state.quantity);
    components = components || selectedComponents(instance);
    instance.state.quotePending = true;
    instance.state.quote = null;
    instance.state.selectedOption = null;
    instance.state.message = "";
    instance.state.messageType = "";
    if (instance.quantity) instance.quantity.disabled = true;
    renderSummary(instance);

    return instance.quoteRequester
      .request(buildQuotePayload(instance.bundle.handle, components, quantity))
      .then(function (result) {
        if (result.stale || cycle !== instance.quoteCycle) return;
        var quote = result.quote;
        if (
          (quote.errors || []).length ||
          !quoteSupportsQuantity(quote, quantity) ||
          !(quote.options || []).length
        ) {
          var error = new Error("No verified bundle options");
          error.quote = quote;
          throw error;
        }
        instance.state.quote = quote;
        instance.state.selectedOption = defaultBundleDeliveryOption(
          quote.options,
          instance.deliveryUI,
        );
        instance.state.quotePending = false;
        instance.state.message = "";
        if (instance.quantity) instance.quantity.disabled = false;
        syncControllerQuantity(instance);
        renderSummary(instance);
        return quote;
      })
      .catch(function (error) {
        if (error && error.name === "AbortError") return;
        failQuote(instance, cycle, error);
      });
  }

  function scheduleQuote(instance) {
    var timerHost =
      (instance.root &&
        instance.root.ownerDocument &&
        instance.root.ownerDocument.defaultView) ||
      window;
    instance.quoteCycle += 1;
    instance.quoteRequester.cancel();
    if (instance.quoteTimer) timerHost.clearTimeout(instance.quoteTimer);
    instance.quoteTimer = null;
    instance.state.quotePending = true;
    instance.state.quote = null;
    instance.state.quoteMatrix = null;
    instance.state.selectedOption = null;
    instance.state.quantity = null;
    resetQuantitySelect(instance, "Checking quantities…");
    renderSummary(instance);
    if (
      Object.keys(instance.controllers).length <
      expectedComponentCount(instance)
    ) {
      return;
    }
    instance.quoteTimer = timerHost.setTimeout(function () {
      loadQuote(instance);
    }, 140);
  }

  function applyMatrixQuantity(instance) {
    var quote = quoteForQuantity(
      instance.state.quoteMatrix,
      instance.state.quantity,
    );
    instance.state.selectedOption = null;
    if (!quote) {
      instance.state.quote = null;
      instance.state.quotePending = false;
      renderSummary(instance);
      return null;
    }
    instance.state.quote = quote;
    instance.state.selectedOption = defaultBundleDeliveryOption(
      quote.options,
      instance.deliveryUI,
    );
    instance.state.quotePending = false;
    instance.state.message = "";
    if (instance.quantity) instance.quantity.disabled = false;
    syncControllerQuantity(instance);
    renderSummary(instance);
    return quote;
  }

  function mountController(instance, role, handle) {
    var slot = instance.controls.querySelector(
      '[data-bb-section-controller-slot="' + role + '"]',
    );
    if (!slot) return;
    var loader =
      typeof window !== "undefined" && window.BadgeBuzzProductSectionController;
    if (!loader) {
      slot.innerHTML =
        '<p class="bb-field__desc" role="alert">The product options could not be loaded.</p>';
      return;
    }
    var token = {};
    var request = controllerRequest(role, handle, instance.products[handle]);
    request.initialQuantity = instance.state.quantity || 1;
    if (role === "lanyard")
      request.initialProperties.Customization = instance.state.lanyardMode;
    request.slot = slot;
    request.loadingMarkup = controllerLoadingPanel(request.label);
    slot.dataset.bbControllerKind = request.kind;
    instance.controllerTokens[role] = token;
    loader
      .mount(request)
      .then(function (controller) {
        if (!controller || instance.controllerTokens[role] !== token) {
          if (controller && typeof controller.disconnect === "function")
            controller.disconnect();
          return;
        }
        instance.controllers[role] = controller;
        var designApi =
          typeof window !== "undefined" &&
          window.BadgeBuzzProductDesignController;
        var shouldMountDesign =
          controller.supportsDesign &&
          (role !== "lanyard" || instance.state.lanyardMode === "Customized");
        var template = instance.root.querySelector(
          '[data-bb-product-design-actions-template="' + role + '"]',
        );
        if (shouldMountDesign && designApi && template) {
          var fragment = template.content.cloneNode(true);
          var actionsRoot = fragment.querySelector(
            "[data-bb-product-design-actions]",
          );
          slot.appendChild(fragment);
          instance.designControllers[role] =
            window.BadgeBuzzProductDesignController.mount({
              root: controller.root,
              actionsRoot: actionsRoot,
              runtimeRoot: instance.runtimeRoot,
              product: {
                handle: handle,
                id: instance.products[handle] && instance.products[handle].id,
                title:
                  instance.products[handle] && instance.products[handle].title,
                options:
                  instance.products[handle] &&
                  instance.products[handle].options,
                zakekeAttributeMap:
                  instance.zakekeAttributeMaps[handle] || null,
              },
              mode: "collect",
              selection: function () {
                return bundleDesignSelection(instance, role, controller);
              },
              beforeOpen: function () {
                if (
                  instance.state.quotePending ||
                  !instance.state.selectedOption
                ) {
                  throw new Error(
                    "Choose a bundle quantity and ready-to-ship date before designing.",
                  );
                }
              },
              onCollect: function (artwork) {
                updateCollectedArtwork(instance, role, artwork);
              },
            });
        }
        controller.root.addEventListener(
          "bb:product-controller-change",
          function () {
            if (
              instance.controllerTokens[role] === token &&
              !instance.syncingQuantity
            )
              scheduleQuote(instance);
          },
        );
        scheduleQuote(instance);
      })
      .catch(function () {
        if (instance.controllerTokens[role] !== token) return;
        instance.state.message =
          "The product options could not be loaded. Please refresh and try again.";
        instance.state.messageType = "error";
        instance.state.quotePending = false;
        renderSummary(instance);
      });
  }

  function render(instance) {
    var state = instance.state;
    var products = instance.products;
    var definition = instance.definition;
    var lanyardHandle = state.lanyardHandle;
    var index = 1;

    releaseControllers(instance);
    instance.quoteCycle += 1;
    instance.quoteRequester.cancel();
    state.quote = null;
    state.quoteMatrix = null;
    state.selectedOption = null;
    state.quotePending = true;
    state.quantity = null;
    resetQuantitySelect(instance, "Loading quantities…");
    var badgeBody = productChoice(
      products,
      definition.badgeProducts,
      state.badgeHandle,
      "badge-product",
      "Name badge type",
      instance.choiceImages,
    );
    badgeBody += '<div data-bb-section-controller-slot="badge"></div>';
    var controls = componentSection(
      index++,
      "Choose your name badges",
      "Select the name badge type, then configure its options.",
      badgeBody,
    );

    if (definition.includesAdhesive) {
      controls += componentSection(
        index++,
        "Choose your adhesive badges",
        "Configure the adhesive name badges included in this bundle.",
        '<div data-bb-section-controller-slot="adhesive"></div>',
      );
    }

    var catalog = productOptionCatalog();
    var lanyardFamilies =
      catalog && Array.isArray(catalog.lanyardFamilies)
        ? catalog.lanyardFamilies
        : definition.lanyardProducts.map(function (handle) {
            return {
              handle: handle,
              label: products[handle] ? products[handle].title : handle,
            };
          });
    var lanyardBody = lanyardFamilyChoice(
      state.lanyardHandle,
      lanyardFamilies,
    );
    lanyardBody += choiceGroup(
      "Customization",
      "lanyard-mode",
      definition.lanyardModes,
      state.lanyardMode,
    );
    lanyardBody += '<div data-bb-section-controller-slot="lanyard"></div>';
    controls += componentSection(
      index,
      "Choose your lanyards",
      "Select the lanyard style, then configure its options.",
      lanyardBody,
    );
    instance.controls.innerHTML = controls;
    if (catalog && catalog.syncBundleLanyardAvailability) {
      catalog.syncBundleLanyardAvailability(instance.controls, state.lanyardHandle, state.lanyardMode);
    }
    var orderHeading = instance.root.querySelector(
      "[data-bb-bundle-order-heading]",
    );
    if (orderHeading)
      orderHeading.textContent = index + 1 + ". Finalize your bundle";
    renderSummary(instance);
    mountController(instance, "badge", state.badgeHandle);
    if (definition.includesAdhesive)
      mountController(instance, "adhesive", "adhesive-name-badge");
    mountController(instance, "lanyard", lanyardHandle);
  }

  function routeRoot() {
    return (
      (typeof window !== "undefined" &&
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      "/"
    );
  }

  function parseResponse(response) {
    return response.text().then(function (text) {
      var data;
      try {
        data = text ? JSON.parse(text) : {};
      } catch (error) {
        data = { description: text || response.statusText };
      }
      if (!response.ok || data.status)
        throw new Error(
          data.description || data.message || "Unable to update the cart.",
        );
      return data;
    });
  }

  function rollback(response) {
    var updates = rollbackUpdates(response);
    if (!Object.keys(updates).length) return Promise.resolve();
    return fetch(routeRoot() + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ updates: updates }),
    }).then(parseResponse);
  }

  function refreshDrawer(trigger) {
    if (typeof window.bbRefreshAndOpenCartDrawer === "function")
      return window.bbRefreshAndOpenCartDrawer(trigger);
    if (typeof window.bbAddToCartAndOpenDrawer === "function") {
      var drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.open === "function") drawer.open(trigger);
    }
    document.dispatchEvent(
      new CustomEvent("bb:cart:refresh", { bubbles: true }),
    );
    return Promise.resolve();
  }

  function addBundle(instance) {
    var components = selectedComponents(instance);
    var option = instance.state.selectedOption;
    var missingArtwork = missingArtworkRoles(instance);
    var bundleKey =
      "bb-" +
      Date.now().toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 8);
    var lines = buildCartLines({
      bundleTitle: instance.bundle.title,
      bundleHandle: instance.bundle.handle,
      bundleKey: bundleKey,
      components: components,
      quoteOption: option,
    });
    if (
      !option ||
      missingArtwork.length > 0 ||
      lines.length !== expectedComponentCount(instance)
    ) {
      instance.state.message = missingArtwork.length
        ? ARTWORK_REQUIRED_MESSAGE
        : "Wait for the current bundle options to be verified.";
      instance.state.messageType = "error";
      renderSummary(instance);
      if (missingArtwork.length) guideMissingArtwork(instance);
      return Promise.resolve();
    }

    instance.state.busy = true;
    instance.state.message = "";
    renderSummary(instance);
    var responseData;
    return fetch(routeRoot() + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: lines }),
    })
      .then(parseResponse)
      .then(function (data) {
        responseData = data;
        if (!addResponseMatches(lines, data)) {
          return rollback(data).then(function () {
            responseData = null;
            throw new Error(
              "Shopify could not add every component at the requested quantity. Nothing was added.",
            );
          });
        }
        instance.state.message =
          "Bundle added. Every component is grouped in your cart.";
        instance.state.messageType = "success";
        return refreshDrawer(
          instance.root.querySelector("[data-bb-bundle-add]"),
        );
      })
      .catch(function (error) {
        if (responseData && addResponseMatches(lines, responseData) === false) {
          return rollback(responseData)
            .catch(function () {})
            .then(function () {
              throw error;
            });
        }
        throw error;
      })
      .catch(function (error) {
        instance.state.message =
          error.message || "The bundle could not be added. Please try again.";
        instance.state.messageType = "error";
      })
      .finally(function () {
        instance.state.busy = false;
        renderSummary(instance);
      });
  }

  function bind(instance) {
    instance.root.addEventListener("click", function (event) {
      var choice = event.target.closest("[data-bb-choice]");
      if (choice) {
        if (choice.disabled || choice.getAttribute("aria-disabled") === "true") return;
        var key = choice.getAttribute("data-bb-choice");
        var value = choice.getAttribute("data-bb-value");
        if (key === "badge-product") {
          instance.state.badgeHandle = value;
          delete instance.artworkByRole.badge;
        }
        if (key === "lanyard-mode") {
          instance.state.lanyardMode = value;
          delete instance.artworkByRole.lanyard;
        }
        if (key === "lanyard-product") {
          instance.state.lanyardHandle = value;
          delete instance.artworkByRole.lanyard;
        }
        instance.state.message = "";
        render(instance);
        return;
      }
      if (event.target.closest("[data-bb-bundle-add]")) addBundle(instance);
    });
    instance.root.addEventListener("change", function (event) {
      if (!event.target.matches("[data-bb-bundle-quantity]")) return;
      var quantity = Number(event.target.value);
      var supported = normalizedSupportedQuantities(
        (instance.state.quote && instance.state.quote.supported_quantities) ||
          Array.prototype.map.call(event.target.options, function (option) {
            return option.value;
          }),
      );
      if (supported.indexOf(quantity) === -1) return;
      instance.state.quantity = quantity;
      if (quoteForQuantity(instance.state.quoteMatrix, quantity))
        applyMatrixQuantity(instance);
      else loadSelectedQuantityQuote(instance);
    });
  }

  function initialize(root) {
    if (!root || root.dataset.bbBundleReady === "true") return null;
    var dataNode = root.querySelector("[data-bb-bundle-data]");
    var controls = root.querySelector("[data-bb-bundle-controls]");
    var summary = root.querySelector("[data-bb-bundle-summary]");
    var quantity = root.querySelector("[data-bb-bundle-quantity]");
    var delivery = root.querySelector("[data-bb-bundle-delivery]");
    if (!dataNode || !controls || !summary || !quantity || !delivery)
      return null;
    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      return null;
    }
    var definition = BUNDLES[data.bundle && data.bundle.handle];
    if (!definition) return null;
    var instance = {
      root: root,
      controls: controls,
      summary: summary,
      bundle: data.bundle,
      products: data.products || {},
      definition: definition,
      quantity: quantity,
      delivery: delivery,
      deliveryUI:
        typeof window !== "undefined" ? window.BadgeBuzzDeliveryDateUI : null,
      runtimeRoot: root.querySelector("[data-bb-product-design-runtime]"),
      zakekeAttributeMaps: data.zakekeAttributeMaps || {},
      choiceImages: data.choiceImages || {},
      controllers: {},
      designControllers: {},
      artworkByRole: {},
      controllerTokens: {},
      quoteCycle: 0,
      quoteTimer: null,
      quoteRequester: createQuoteRequester(fetch, quoteCache),
      syncingQuantity: false,
    };
    instance.state = defaultState(definition);
    root.bbBundleConfigurator = instance;
    root.dataset.bbBundleReady = "true";
    bind(instance);
    render(instance);
    return instance;
  }

  function initializeAll(scope) {
    (scope || document)
      .querySelectorAll("[data-bb-bundle-configurator]")
      .forEach(initialize);
  }

  if (typeof document !== "undefined") {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", function () {
        initializeAll(document);
      });
    else initializeAll(document);
    document.addEventListener("shopify:section:load", function (event) {
      initializeAll(event.target);
    });
    document.addEventListener("shopify:section:unload", function (event) {
      event.target
        .querySelectorAll("[data-bb-bundle-configurator]")
        .forEach(function (root) {
          var instance = root.bbBundleConfigurator;
          if (!instance) return;
          instance.quoteCycle += 1;
          instance.quoteRequester.cancel();
          if (instance.quoteTimer) window.clearTimeout(instance.quoteTimer);
          releaseControllers(instance);
          delete root.bbBundleConfigurator;
          delete root.dataset.bbBundleReady;
        });
    });
  }

  return {
    findVariant: findVariant,
    componentFromController: componentFromController,
    buildQuotePayload: buildQuotePayload,
    quoteFingerprint: quoteFingerprint,
    normalizedSupportedQuantities: normalizedSupportedQuantities,
    quoteSupportsQuantity: quoteSupportsQuantity,
    quoteForQuantity: quoteForQuantity,
    createQuoteRequester: createQuoteRequester,
    resetQuantitySelect: resetQuantitySelect,
    populateQuantitySelect: populateQuantitySelect,
    bundleDeliveryOptions: bundleDeliveryOptions,
    defaultBundleDeliveryOption: defaultBundleDeliveryOption,
    choiceGroup: choiceGroup,
    lanyardFamilyChoice: lanyardFamilyChoice,
    productChoice: productChoice,
    deliveryUIReady: deliveryUIReady,
    controllerLoadingPanel: controllerLoadingPanel,
    componentSection: componentSection,
    publicQuoteMessage: publicQuoteMessage,
    buildCartLines: buildCartLines,
    bundleDesignSelection: bundleDesignSelection,
    addResponseMatches: addResponseMatches,
    rollbackUpdates: rollbackUpdates,
    componentNeedsArtwork: componentNeedsArtwork,
    missingArtworkRoles: missingArtworkRoles,
    guideMissingArtwork: guideMissingArtwork,
    updateCollectedArtwork: updateCollectedArtwork,
    defaultSelectionForBundle: defaultSelectionForBundle,
    controllerRequest: controllerRequest,
    renderSummary: renderSummary,
    addBundle: addBundle,
    scheduleQuote: scheduleQuote,
    loadQuote: loadQuote,
    loadSelectedQuantityQuote: loadSelectedQuantityQuote,
    applyMatrixQuantity: applyMatrixQuantity,
    initialize: initialize,
  };
});
